import React from 'react'
import { Icon } from 'antd'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'

CodeIcon.propTypes = {
  code: PropTypes.string,
  title: PropTypes.string,
}

function CodeIcon(props) {
  return (
    <h2 className={'icon-text-header'}>
      <Icon
        type="barcode"
        style={{
          marginRight: '5px',
          color: '#08c',
        }}
      />
      <Tooltip title={props.title}>{props.code}</Tooltip>
    </h2>
  )
}

export default CodeIcon
